















































































import {Component, Ref, Vue} from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import {cloneDeep, isEqual} from "lodash";
import { SelectWings } from "wings-ui-components";
import { notifyConfirm, notifyDelete, notifyError } from "@/utils/notify-helper";
import { ApplicationAttributeItem } from "@/store/push/attributes/types";
import {ActionLog} from "@/store/auth/types";
import {getTranslatedParams} from "@/utils/notify-utils";

Component.registerHooks([
  'beforeRouteLeave',
]);

@Component({components: { SelectWings }})
export default class ApplicationAttribute extends Vue {
  @Getter("attributeTypeList") attributeTypeList: any;
  @Getter("attributeOwnerList") attributeOwnerList: any;
  @Action("getApplicationAttributeItem") actionGetItem: any;
  @Action("saveApplicationAttribute") actionSave: any;
  @Action("deleteApplicationAttribute") actionDelete: any;
  @Action("actionLog") actionLog: any;
  @Ref('validator') validator:any;

  private item:ApplicationAttributeItem = this.defaultItem();
  private itemSaved:ApplicationAttributeItem = this.defaultItem();
  private logObject: ActionLog = {};

  async created() {
    if (this.$route.params.id) {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Push application attribute",
        object_name: this.item.name,
        addititional_info: getTranslatedParams({application_id: this.$route.params.application_id, id: this.$route.params.id})
      }
      try {
        const data: ApplicationAttributeItem = await this.actionGetItem({
          application_id: this.$route.params.application_id,
          id: this.$route.params.id
        });
        this.item = Object.assign({}, this.item, data);
        this.itemSaved = cloneDeep(Object.assign({}, this.item, data));
        await this.actionLog(this.logObject);
      } catch (err) {
        this.actionLog({...this.logObject, action_status: "failed"})
      }
    }
  }

  back():void{
    this.$router.push(`/push/applications/attributes`);
  }

  defaultItem(): ApplicationAttributeItem {
    return {
      name: '',
      type: '',
      owner: '',
    }
  }

  async onSaveItem():Promise<void> {
    const valid:boolean = await this.validator.validate();
    if (valid) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: this.$route.params.id ? "Editing" : "Creation",
          action_status: "success",
          object_type: "Push application attribute",
          object_name: this.item.name,
          addititional_info: getTranslatedParams(this.item)
        }
        await this.actionSave({
          application_id: this.$route.params.application_id,
          item: this.item
        });
        await this.actionLog(this.logObject);
        this.itemSaved = this.item;
        this.back();
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
        throw error;
      }
    } else {
      setTimeout(() => {
        notifyError(null, this.validator.errors)
      }, 100);
      throw new Error();
    }
  }

  async onDeleteItem():Promise<void> {
    let isConfirm:boolean = await notifyDelete();
    if (isConfirm) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Removal",
          action_status: "success",
          object_type: "Push application attribute",
          object_name: this.item.name,
          addititional_info: getTranslatedParams({id: this.item.id})
        }
        await this.actionDelete({
          application_id: this.$route.params.application_id,
          item: this.item
        });
        await this.actionLog(this.logObject);
        this.itemSaved = this.item;
        this.back();
      } catch (error) {
        await this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
      }
    }
  }

  beforeRouteLeave(to:any, from:any, next:any) {
    let isChange = !isEqual(this.item,this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }
}
